module.exports = __webpack_public_path__ + "img/pingtai.cbcf4018.png";